import {Component, OnInit, OnDestroy} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {TermsService} from '../../services/terms.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-accept-terms',
  templateUrl: './accept-terms.component.html',
  styleUrls: ['./accept-terms.component.scss']
})
export class AcceptTermsComponent implements OnInit, OnDestroy {
  termsText: string;
  private langSub: Subscription;

  constructor(
    private dialogRef: MatDialogRef<AcceptTermsComponent>,
    private termsService: TermsService,
    private translate: TranslateService
  ) {
    this.termsText = this.termsService.getTermsTextCarsStandard();
  }

  ngOnInit(): void {
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.termsText = this.termsService.getTermsTextCarsStandard();
    });
  }

  approve() {
    this.dialogRef.close({approve: true});
  }

  close() {
    this.dialogRef.close({approve: false});
  }

  ngOnDestroy(): void {
    if (this.langSub) { this.langSub.unsubscribe(); }
  }
}
